import { SegmentedControl, SegmentedControlItem } from '@optimus-web/core';
import { lt } from '@mews/framework';
import { AuthorizationType } from '@mews-commander/data-access';
import { AuthorizationTypeSegmentTabs } from './AuthorizationTypeSegmentTabs';

interface AuthorizationTypeSegmentControlProps {
    activeAuthorizationTypeSegment: AuthorizationType;
    setActiveAuthorizationTypeSegment: (segment: AuthorizationType) => void;
    accountId: string;
    isExternal: boolean;
    cardPaymentItemLabel: React.ReactNode;
}
export const AuthorizationTypeSegmentControl = ({
    activeAuthorizationTypeSegment,
    setActiveAuthorizationTypeSegment,
    accountId,
    isExternal,
    cardPaymentItemLabel,
}: AuthorizationTypeSegmentControlProps) => (
    <>
        <SegmentedControl
            value={activeAuthorizationTypeSegment}
            onChange={(e, tab) => {
                e.stopPropagation();
                e.preventDefault();
                setActiveAuthorizationTypeSegment(tab as AuthorizationType);
            }}
            size="small"
        >
            <SegmentedControlItem
                label={lt('PreauthorizationPlural')}
                value={AuthorizationType.Preauthorization}
                name="AuthorizationTypeSegmentItem"
            />
            <SegmentedControlItem
                label={cardPaymentItemLabel}
                value={AuthorizationType.CreditCardPayment}
                name="AuthorizationTypeSegmentItem"
            />
        </SegmentedControl>
        <AuthorizationTypeSegmentTabs
            activeSegment={activeAuthorizationTypeSegment}
            accountId={accountId}
            isExternal={isExternal}
        />
    </>
);
